module.exports = __webpack_public_path__ + "media/assets/images/mockup/phone_full_scanner-bbded10bfaf1fdcdf29e7ad1b6b29524.png";